export default __webpack_public_path__ + "static/media/Thumb_Facial_Hair_10.b149367e.png";